import React from 'react';
import PropTypes from 'prop-types';
import BigCalendar from 'react-big-calendar';
import { accessor } from 'react-big-calendar/lib/utils/accessors';
import moment from 'moment-timezone';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import CalendarUtils from 'services/CalendarUtils';
import Icon from 'components/Utils/NewIcon';

// remember the browser's local timezone, as it might by used later on
BigCalendar.tz = CalendarUtils.getCurrentTimezone();
// format all dates in BigCalendar as they would be rendered in browser's local timezone (even if later on they won't)
const m = (...args) => moment.tz(...args, BigCalendar.tz);
m.localeData = moment.localeData;

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(m));

export const convertDateTimeToDate = (datetime, timeZoneName) => {
  const m = moment.tz(datetime, timeZoneName);
  return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
};

export const convertDateToDateTime = (date) => {
  const dateM = moment.tz(date, BigCalendar.tz);
  return moment.tz(
    {
      year: dateM.year(),
      month: dateM.month(),
      date: dateM.date(),
      hour: dateM.hour(),
      minute: dateM.minute(),
    },
    BigCalendar.tz,
  );
};

const TimeZoneAgnosticBigCalendar = (props) => {
  let { onSelectSlot, onEventDrop } = props;

  function startAccessor(event) {
    const start = accessor(event, props.startAccessor);
    return convertDateTimeToDate(start, props.timeZoneName);
  }

  function endAccessor(event) {
    const end = accessor(event, props.endAccessor);
    return convertDateTimeToDate(end, props.timeZoneName);
  }

  function getNow() {
    return CalendarUtils.convertFromTargetTimezone(moment());
  }

  const bigCalendarProps = {
    ...props,
    startAccessor: startAccessor,
    endAccessor: endAccessor,
    getNow: getNow,
    onSelectSlot:
      onSelectSlot &&
      (({ start, end, slots }) => {
        onSelectSlot({
          start: convertDateToDateTime(start),
          end: convertDateToDateTime(end),
          slots: slots.map((date) => convertDateToDateTime(date)),
        });
      }),
    onEventDrop:
      onEventDrop &&
      (({ event, start, end }) => {
        onEventDrop({
          event,
          start: convertDateToDateTime(start),
          end: convertDateToDateTime(end),
        });
      }),
  };
  return <BigCalendar {...bigCalendarProps} />;
};

export const CalendarMonthToolbar = ({ date, setDate, style, chevronHeight = '10px' }) => (
  <div
    className="calendar-month-toolbar my-4 w-100 text-center flex flex-row place-content-center"
    style={style}
  >
    <Icon
      src="chevron-left"
      height={chevronHeight}
      className="m-0"
      onClick={() => setDate(moment.unix(date).add(-1, 'month').unix())}
    />
    <span className="mx-3" style={{ width: '170px' }}>
      {moment.unix(date).format('MMMM YYYY')}
    </span>
    <Icon
      src="chevron-right"
      height={chevronHeight}
      className="m-0"
      onClick={() => setDate(moment.unix(date).add(1, 'month').unix())}
    />
  </div>
);

TimeZoneAgnosticBigCalendar.defaultProps = {
  startAccessor: 'start',
  endAccessor: 'end',
};

TimeZoneAgnosticBigCalendar.propTypes = {
  events: PropTypes.array,
  onSelectSlot: PropTypes.func,
  onEventDrop: PropTypes.func,
  timeZoneName: PropTypes.string,
  startAccessor: PropTypes.string,
  endAccessor: PropTypes.string,
};

export default TimeZoneAgnosticBigCalendar;
